import { isInboxPlanVersionSmallerThan17 } from 'ducks/billing'
import { capitalize, pluralize } from 'util/strings'

export const normalizeDays = count => {
  if (count === 'unlimited') return capitalize(count)
  const months = parseInt(count / 30, 10)
  if (months <= 1) {
    return `${count} ${pluralize(count, 'day')}`
  }
  return `${months} ${pluralize(months, 'month')}`
}

const planVersionsWithMinAgents = ['v2', 'v3', 'v14']

export const getFeatureTitles = ({ isKb, showKbPlans, versions } = {}) => {
  const kbName =
    isKb || showKbPlans ? 'Knowledge Bases' : 'Full Knowledge Bases'
  const showNewFeatures = versions.some(
    version => !isInboxPlanVersionSmallerThan17(version)
  )
  const showMinAgents = versions.some(version =>
    planVersionsWithMinAgents.includes(version)
  )
  if (isKb) {
    const KbFeatures = [
      {
        name: kbName,
        key: 'maxKbs',
      },
      {
        name: 'Articles',
        key: 'maxArticles',
      },
      {
        name: 'Reporting History',
        key: 'maxReportingDays',
        normalizer: normalizeDays,
      },
      {
        name: 'SEO settings',
        key: 'seo',
      },
      {
        name: 'Custom Scripts',
        key: 'customScripts',
      },
      {
        name: 'Access Control',
        key: 'private',
      },
      {
        name: 'Remove Groove branding',
        key: 'branding',
      },
    ]
    return {
      header: {
        key: 'header',
        list: KbFeatures,
      },
    }
  }
  const headerGroup = [
    {
      name: `Minimum ${app.t('agent')}`,
      key: 'minimumQuantity',
      hidden: !showMinAgents,
    },
    {
      name: `Maximum ${app.t('Agents')}`,
      key: 'maxUsers',
    },
  ]

  const productsGroup = [
    {
      name: !showNewFeatures ? app.t('Mailboxes') : 'Channels',
      key: !showNewFeatures ? 'maxMailboxes' : 'maxChannels',
      tooltip: !showNewFeatures
        ? undefined
        : 'This includes email, social and live chat channels',
    },
    {
      name: 'Live Chat',
      key: 'liveChat',
      hidden: !showNewFeatures,
    },
    {
      name: kbName,
      key: 'maxKbs',
      hidden: !showNewFeatures && showKbPlans,
    },
    {
      name: 'Widgets',
      key: 'maxWidgets',
      hidden: !showNewFeatures,
    },
    {
      name: 'Search History',
      key: 'maxSearchHistoryDays',
      normalizer: normalizeDays,
      hidden: !showNewFeatures,
    },
    {
      name: 'Reporting History',
      key: 'maxReportingDays',
      normalizer: normalizeDays,
    },
  ]

  const inboxGroup = [
    {
      name: 'Teams',
      key: 'teams',
    },
    {
      name: 'Satisfaction Ratings',
      key: 'satisfactionsRatings',
    },
    {
      name: app.t('Canned_Replies'),
      key: 'maxCannedReplies',
    },
    {
      name: `${app.t('Canned_Reply')} Actions`,
      key: 'cannedRepliesTier1',
      tooltip: `This feature allows you to add actions when using an ${app.t(
        'Canned_Reply'
      )}, such as tagging, assigning or snoozing a conversation`,
    },
    {
      name: `${app.t('Folders')}`,
      key: 'maxFolders',
    },
    {
      name: 'Rules',
      key: 'maxRules',
    },
    {
      name: 'Advanced Rules',
      key: 'rulesTier1',
      tooltip:
        'Get even more out of rules with additional firing triggers, conditions and actions',
    },
    {
      name: 'Time Based Rules',
      key: 'rulesTier2',
    },
    {
      name: 'Round Robin with Load balancing',
      key: 'roundRobin',
      tooltip: `Automatically assign conversations to the ${app.t(
        'agents'
      )} that have the most availability`,
    },
    {
      name: 'Integrations',
      key: 'maxIntegrations',
    },
    {
      name: 'Premium integrations',
      key: 'premiumIntegrations',
    },
  ]

  const advancedGroup = [
    {
      name: `Custom Profile`,
      key: 'customProfile',
    },
    {
      name: `Remove Groove branding`,
      key: 'branding',
      tooltip:
        'Remove Groove branding from footer of Knowledge Base, Help Widget and Live Chat',
    },
    {
      name: `Custom Fields`,
      key: 'customFields',
    },
    {
      name: `API Access`,
      key: 'apiAccess',
    },
    {
      name: `Data Export`,
      key: 'exports',
    },
  ]

  return {
    header: {
      key: 'header',
      list: headerGroup.filter(item => !item.hidden),
    },
    products: {
      title: 'Products',
      key: 'products',
      list: productsGroup.filter(item => !item.hidden),
    },
    inbox: {
      title: `${app.t('Mailbox')} features`,
      key: 'inbox',
      list: inboxGroup.filter(item => !item.hidden),
    },
    advanced: {
      title: 'Advanced',
      key: 'advanced',
      list: advancedGroup.filter(item => !item.hidden),
    },
  }
}
